export default "__VITE_ASSET__BdKE8vDY__"